/* eslint-disable arrow-body-style */
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT,
  LOGOUT_SUCCESS,

  GET_IS_AUTH,
  GET_IS_AUTH_SUCCESS,
  GET_IS_AUTH_ERROR,
  SET_LOADING,

  MFA_REQUIRED,
  MFA_VERIFY,
  MFA_VERIFY_SUCCESS,
  MFA_VERIFY_ERROR,
  MFA_CLEAR,
  MFA_HYDRATE,
} from '../types/actionTypes';

export const login = (payload) => {
  return {
    type: LOGIN,
    payload,
  };
};

export const loginSuccess = (payload) => {
  return {
    type: LOGIN_SUCCESS,
    payload,
  };
};

export const loginError = (payload) => {
  return {
    type: LOGIN_ERROR,
    payload,
  }
};

export const logout = () => ({
  type: LOGOUT,

});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const getIsAuth = () => {
  return {
    type: GET_IS_AUTH,
  };
};

export const getIsAuthSuccess = (payload) => {
  return {
    type: GET_IS_AUTH_SUCCESS,
    payload,
  };
};

export const getIsAuthError = () => ({
  type: GET_IS_AUTH_ERROR,
});

export const setLoading = (payload) => ({
  type: SET_LOADING,
  payload,
});

// ========================= MFA =============================================
export const mfaRequired = (payload) => ({
  type: MFA_REQUIRED,
  payload,
});

export const mfaVerify = (payload) => ({
  type: MFA_VERIFY,
  payload,
});

/* export const mfaVerifySuccess = (payload) => ({ 
  type: MFA_VERIFY_SUCCESS, 
  payload 
}); */

export const mfaVerifyError = (payload) => ({
  type: MFA_VERIFY_ERROR,
  payload,
});

export const mfaClear = () => ({
  type: MFA_CLEAR,
});

// Refresh de MFA desde sessionStorage si recargan la página
/* export const mfaHydrate = (payload) => ({ 
  type: MFA_HYDRATE, 
  payload 
}); */

// ===========================================================================
